import { Link } from 'react-router-dom';
import { useEffect, useRef } from 'react';

export default function CtaBanner() {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const o = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) ref.current?.classList.add('visible');
    }, { threshold: 0.15 });
    if (ref.current) o.observe(ref.current);
    return () => o.disconnect();
  }, []);

  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/02103671c38c9d78c2ebe8c202a2f673.jpg"
          alt="Premium furniture design consultation Las Vegas"
          title="Book a Free Design Consultation - Eclectic Home"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-dark/80" />
        {/* Decorative vertical line */}
        <div className="absolute top-0 bottom-0 left-1/2 w-px bg-white/5" />
      </div>

      <div ref={ref} className="fade-up relative z-10 max-w-7xl mx-auto px-6 py-28">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Left */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-gold" />
              <span className="text-gold text-xs font-bold uppercase tracking-[0.25em]">Complimentary Service</span>
            </div>
            <h2 className="font-serif font-bold text-white leading-tight mb-6" style={{ fontSize: 'clamp(36px, 4vw, 64px)' }}>
              Your Perfect Home
              <br />
              Starts With a
              <br />
              <em className="text-gold not-italic">Conversation.</em>
            </h2>
            <p className="text-white/55 text-base leading-relaxed">
              Meet with our certified interior consultants for a free design session — 
              in-showroom or virtual. We&apos;ll help you find pieces that work together beautifully, 
              fit your space, and respect your budget.
            </p>
          </div>

          {/* Right */}
          <div className="flex flex-col gap-5 lg:pl-8">
            {/* Trust points */}
            <div className="space-y-4">
              {[
                { icon: 'ri-check-double-line', text: 'No obligation — completely free design consultation' },
                { icon: 'ri-check-double-line', text: 'In-person or virtual appointments available' },
                { icon: 'ri-check-double-line', text: 'Space planning + furniture selection included' },
                { icon: 'ri-check-double-line', text: 'White-glove delivery & professional assembly' },
              ].map((item) => (
                <div key={item.text} className="flex items-center gap-4">
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`${item.icon} text-gold`} />
                  </div>
                  <span className="text-white/70 text-sm">{item.text}</span>
                </div>
              ))}
            </div>

            {/* CTAs */}
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <Link
                to="/showroom"
                className="text-center bg-gold text-white px-8 py-4 rounded-lg text-sm font-bold uppercase tracking-widest hover:bg-gold-dark transition-colors cursor-pointer whitespace-nowrap"
              >
                Book a Consultation
              </Link>
              <Link
                to="/collections"
                className="text-center border border-white/30 text-white px-8 py-4 rounded-lg text-sm font-semibold uppercase tracking-widest hover:border-white/60 hover:bg-white/5 transition-all cursor-pointer whitespace-nowrap"
              >
                Explore Collection
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
